module.exports = __webpack_public_path__ + "static/img/pico24.8cf492a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico24.png
// module id = L5HH
// module chunks = 0